import config from '../config/config';
import REST_API_NAMES from '../config/restApiNames';
import axios from 'axios';
import SafeConsole from '../util/ConsoleUtils';

export function callApi({
  method,
  url,
  queryParams,
  headers = {},
  body,
  processResponse = true,
  shouldRetry = () => {},
  retries = 0,
  timeBetweenRetries = 500,
}) {
  const urlObj = new URL(url);
  if (queryParams) {
    Object.keys(queryParams).forEach((key) => urlObj.searchParams.append(key, queryParams[key]));
  }
  let headersObj = null;
  if (headers) {
    headersObj = new Headers(headers);
  }
  let bodyObj = null;
  if (body) {
    bodyObj = body;
  }
  const request = new Request(urlObj, {
    method: method,
    headers: headersObj,
    body: bodyObj,
  });
  /*eslint-env es6 */
  var p = new Promise((resolve, reject) => {
    var retry = 0;
    const doFetch = () => {
      fetch(request.clone())
        .then((res) => {
          if (processResponse && res) {
            if (res.status >= 200 && res.status < 300) {
              return res.json();
            } else {
              throw { status: res.status, statusText: res.statusText };
            }
          } else {
            resolve({});
          }
        })
        .then((result) => {
          let reason = shouldRetry(result);
          if (reason) {
            throw reason;
          } else {
            resolve(result);
          }
        })
        .catch((err) => {
          if (retries > 0) {
            // do retries
            retry++;
            if (retry <= retries) {
              setTimeout(doFetch, timeBetweenRetries);
            } else {
              reject(err);
            }
          } else {
            reject(err);
          }
        });
    };

    doFetch();
  });
  return p;
}

export default class ApiUtil {
  static MAX_RETRIES = 2;
  static TIME_BETWEEN_RETRIES = 500; // in millis
  static FETCH_TIMEOUT = 15000;

  static doGet(url, data, shouldRetry) {
    var ajaxData = {
      method: 'GET',
      url: url,
      header: {
        contentType: 'application/json',
      },
    };
    return ApiUtil._ajax(ajaxData);
  }

  static _ajax({ method, url, body, header }, others, errorCallback) {
    let didTimeOut = false;

    const timeout = setTimeout(() => {
      didTimeOut = true;
      return { error: 'timeout' };
    }, ApiUtil.FETCH_TIMEOUT);

    return fetch(url, {
      body,
      method,
      header,
      others,
    })
      .then((resp) => {
        clearTimeout(timeout);
        if (didTimeOut) {
          throw new Error('Timeout');
        }
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        return resp;
      })
      .then((response) => {
        SafeConsole.log(response);
        return response;
      })
      .catch(function(err) {
        SafeConsole.log('fetch failed! ', err);
        if (didTimeOut) {
          return;
        }

        return (err) => errorCallback(err);
      });
  }
  static doPost(url, data, shouldRetry) {
    var ajaxData = {
      method: 'POST',
      url: url,
      body: JSON.stringify(data),
      header: {
        contentType: 'application/json',
      },
    };
    return ApiUtil._ajax('POST', ajaxData, shouldRetry);
  }
}

export const campaignHttpHeaders = {
  'x-asurion-carrierid': 'VZW',
  'x-asurion-serverapikey': 'XHqu4CUrpw5ObdmVblbYx1yq0spGzzmq8RlTxAx8',
};

export const getAndSetCampaignDetails = (messageId, executeOnSuccess) => {
  const headers = {
    headers: campaignHttpHeaders,
  };

  try {
    return axios.get(config.REST_URL(REST_API_NAMES.campaignDetails) + messageId, headers).then((response) => {
      saveCampaignDetailsToLocal(response.data);
      if (typeof executeOnSuccess === 'function') {
        executeOnSuccess();
      }
    });
  } catch (ex) {
    console.error(ex);
  }
};

export const saveCampaignDetailsToLocal = (data) => {
  const { universalId, ...otherCampaignDetails } = data;
  if (universalId) {
    window.localStorage.setItem('universalId', universalId);
  }
  const applicationId = otherCampaignDetails['applicationId'];
  const contractid = otherCampaignDetails['contractid'];
  if (applicationId || contractid) {
    window.localStorage.setItem('distinctId', applicationId || contractid);
  }
  window.sessionStorage.setItem('otherCampaignDetails', JSON.stringify(otherCampaignDetails));
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/ApiUtil.js